import { apiGet, apiPost, apiPut, apiDelete } from 'helpers/ApiHelper';
import { onlyNumbers, toDate, toISO8601DateString } from 'helpers/Formatter';

import Auth from 'j-toker';
import * as notifications from './notificationActions';

export function returnDeposit(payment_id, interest_amount, reference_number) {
  const form_data = {
    payment_id,
    interest_amount: onlyNumbers(interest_amount),
    reference_number: reference_number,
  };
  return dispatch => {
    return dispatch({
      payload: apiPost(Auth.getApiUrl() + `/landlords/return_deposit`, form_data)
        .done(response => {
          dispatch(clearPaymentInfoDialog());
          dispatch(getOutstandingDeposits(false));
          dispatch(notifications.showSuccess('depositSuccessfullyReturnedToTenant'));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function undoDeposit(payment_id) {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/landlords/undo_deposit/${payment_id}`)
        .done(response => {
          dispatch(clearPaymentInfoDialog());
          dispatch(getOutstandingDeposits(true));
          dispatch(notifications.showSuccess('depositReturnSuccessfullyUndone'));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function reportNSF(payment_id, form_data) {
  return dispatch => {
    return dispatch({
      payload: apiPut(Auth.getApiUrl() + `/landlords/nsf_payments/${payment_id}`, form_data)
        .done(response => {
          dispatch(clearPaymentInfoDialog());
          dispatch(notifications.showSuccess('nsfPaymentSuccessfullyCreated'));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function submitLatePayment(payment_id, form_data) {
  return dispatch => {
    return dispatch({
      payload: apiPut(Auth.getApiUrl() + `/landlords/payment/${payment_id}/late_payment`, form_data)
        .done(response => {
          dispatch(clearPaymentInfoDialog());
          dispatch(notifications.showSuccess('paymentSuccessfullyMarkedAsLate'));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function createInterest(formData) {
  if (formData['interest_start_date'])
    formData['interest_start_date'] = toISO8601DateString(formData['interest_start_date']);
  if (formData['interest_end_date'])
    formData['interest_end_date'] = toISO8601DateString(formData['interest_end_date']);

  return dispatch => {
    return dispatch({
      payload: apiPost(Auth.getApiUrl() + '/landlords/interest', formData)
        .done(response => {
          dispatch(notifications.showSuccess('interestCalculationRangeSuccessfullyCreated'));
          dispatch(getInterestPeriods());
        })
        .catch(error => {
          dispatch(notifications.showFailure(error));
        }),
    });
  };
}

export function getInterestPeriods() {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + '/landlords/interest')
        .done(response => {
          dispatch(saveInterestPeriods(response.deposit_interests));
        })
        .catch(error => {
          dispatch(notifications.showFailure(error));
        }),
    });
  };
}

export function saveInterestPeriods(interestPeriods) {
  return {
    type: 'LANDLORD_PAYMENTS::SHOW_INTEREST_CALCULATION_RANGES',
    interestPeriods,
  };
}

export function deleteInterestPeriod(interest_period_id) {
  return dispatch => {
    return dispatch({
      payload: apiDelete(Auth.getApiUrl() + `/landlords/interest/${interest_period_id}`)
        .done(response => {
          dispatch(notifications.showSuccess('interestPeriodSuccessfullyDeleted'));
          dispatch(getInterestPeriods());
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function createPayment(formData) {
  formData['property_id'] = formData['property']['value'];
  if (formData['unit_selected']) formData['unit_number'] = formData['unit_selected']['label'];
  if (formData['due_date']) formData['due_date'] = toISO8601DateString(formData['due_date']);
  if (formData['payment_date'])
    formData['payment_date'] = toISO8601DateString(formData['payment_date']);

  return dispatch => {
    return dispatch({
      payload: apiPost(Auth.getApiUrl() + '/landlords/payment', formData)
        .done(response => {
          dispatch(notifications.showSuccess('paymentSuccessfullyCreated'));
        })
        .catch(error => {
          dispatch(notifications.showFailure(error));
        }),
    });
  };
}

export function useDeposit(payment_id) {
  return dispatch => {
    return dispatch({
      payload: apiPut(Auth.getApiUrl() + `/landlords/use_deposit/${payment_id}`)
        .done(response => {
          dispatch(clearPaymentInfoDialog());
          dispatch(notifications.showSuccess('paymentDepositSuccessfullyAppliedToPayment'));
        })
        .catch(error => {
          dispatch(notifications.showFailure(error));
        }),
    });
  };
}

export function wavePayment(payment_id) {
  return dispatch => {
    return dispatch({
      payload: apiPut(Auth.getApiUrl() + `/landlords/waive_payment/${payment_id}`)
        .done(response => {
          dispatch(clearPaymentInfoDialog());
          dispatch(notifications.showSuccess('paymentSuccessfullyWaved'));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function unwavePayment(payment_id) {
  return dispatch => {
    return dispatch({
      payload: apiPut(Auth.getApiUrl() + `/landlords/unwaive_payment/${payment_id}`)
        .done(response => {
          dispatch(notifications.showSuccess('paymentSuccessfullyUnwaved'));
          dispatch(clearPaymentInfoDialog());
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function delayPayment(payment_id, delay_date) {
  delay_date = toISO8601DateString(delay_date.payment_delay_date);
  return dispatch => {
    return dispatch({
      payload: apiPut(Auth.getApiUrl() + `/landlords/delay_payment/${payment_id}`, { delay_date })
        .done(response => {
          dispatch(notifications.showSuccess('paymentSuccessfullyDelayed'));
          dispatch(clearPaymentInfoDialog());
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function deleteTransactionPayment(transaction_payment_id) {
  return dispatch => {
    return dispatch({
      payload: apiDelete(
        Auth.getApiUrl() + `/landlords/transaction_payments/${transaction_payment_id}`
      )
        .done(response => {
          dispatch(notifications.showSuccess('paymentSuccessfullyDeleted'));
          dispatch(clearPaymentInfoDialog());
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function deletePayment(payment_id) {
  return dispatch => {
    return dispatch({
      payload: apiDelete(Auth.getApiUrl() + `/landlords/payments/${payment_id}`)
        .done(response => {
          dispatch(notifications.showSuccess('paymentSuccessfullyDeleted'));
          dispatch(clearPaymentInfoDialog());
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function updatePayment(formData, payment_id) {
  return dispatch => {
    return dispatch({
      payload: apiPut(Auth.getApiUrl() + `/landlords/payments/${payment_id}`, formData)
        .done(response => {
          dispatch(notifications.showSuccess('paymentSuccessfullyUpdated'));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function openPaymentDialog(paymentId) {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/landlords/payment/${paymentId}`)
        .done(response => {
          dispatch(openPaymentInfoDialog(response.payment_details));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function savePaymentDetails(depositDetails) {
  return {
    type: 'LANDLORD_PAYMENTS::SAVE_PAYMENT_DETAILS',
    depositDetails,
  };
}

export function openPaymentInfoDialog(paymentDetails) {
  return {
    type: 'LANDLORD_PAYMENTS::SHOW_PAYMENTS_INFO_DIALOG',
    paymentDetails,
  };
}

export function clearPaymentInfoDialog() {
  return {
    type: 'LANDLORD_PAYMENTS::SHOW_PAYMENTS_INFO_DIALOG',
    paymentDetails: { historic_payments: [], payment_details: [], tenants: [] },
  };
}

export function getTenantList(payment_id) {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/landlords/list_of_tenants?payment_id=${payment_id}`)
        .done(response => {
          if (response.data && response.data.length === 0) {
            dispatch(saveTenantList([]));
          } else {
            dispatch(saveTenantList(response));
          }
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function saveTenantList(response) {
  response.push({ value: 'none', label: 'All Tenants' });
  return {
    type: 'LANDLORD_PAYMENTS::GET_TENANT_LIST',
    tenants: response,
  };
}

export function reportPayment(formData) {
  if (formData['payment_date']) {
    formData['payment_date'] = toISO8601DateString(formData['payment_date']);
  }
  return dispatch => {
    return dispatch({
      payload: apiPost(Auth.getApiUrl() + '/landlords/payments', formData)
        .done(response => {
          dispatch(notifications.showSuccess('paymentSuccessfullyReported'));
          dispatch(clearPaymentInfoDialog());
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function getOutstandingDeposits(deposit_returned) {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/landlords/deposits?deposit_returned=${deposit_returned}`)
        .done(response => {
          dispatch(clearPayments());
          dispatch(displayDeposits(response));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function displayDeposits(response) {
  let deposits = response.deposits.map(deposit => {
    deposit.due_date = toDate(deposit.due_date);
    return deposit;
  });

  return {
    type: 'LANDLORD_PAYMENTS::SHOW_DEPOSITS',
    deposits,
    csv_url: response.url,
  };
}

export function getPaymentStats() {
  const route = '/landlords/payment_stats';
  return dispatch => {
    return dispatch({
      type: 'LANDLORD_PAYMENTS::FETCH_PAYMENT_STATS',
      payload: apiGet(Auth.getApiUrl() + route).done(response => {
        dispatch({
          type: 'LANDLORD_PAYMENTS::SAVE_PAYMENT_STATS',
          payload: response.detailed_payments_counts,
        });
      }),
    });
  };
}

export function getFilteredPayments(subset = 'outstanding', offset = 0, options = {}) {
  return dispatch => {
    return dispatch({
      type: 'LANDLORD_RENT_ROLL::FETCH_PAYMENTS',
      payload: apiPost(
        `${Auth.getApiUrl()}/landlords/filtered_payments?subset=${subset}&offset=${offset}`,
        options
      )
        .done(response => {
          dispatch(displayPayments(response.payments, Date.now(), offset || 0));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function getPreviousPayments() {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + '/landlords/previous_payments')
        .done(response => {
          dispatch(clearPayments());
          dispatch(displayPayments(response));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function displayPayments(response, timestamp, offset) {
  return {
    type: 'LANDLORD_PAYMENTS::SHOW_PAYMENTS',
    payments: response,
    timestamp,
    offset,
  };
}

export function clearPayments() {
  return {
    type: 'LANDLORD_PAYMENTS::SHOW_PAYMENTS',
    payments: [],
    timestamp: Date.now(),
    offset: 0,
  };
}
